import Headroom from 'headroom.js';

const header = document.querySelector('.site-header');

if (header) {
    new Headroom(header, {offset: 50}).init();
}
